import { render, staticRenderFns } from "./gyycshAuditList.vue?vue&type=template&id=96f814f6&scoped=true"
import script from "./gyycshAuditList.vue?vue&type=script&lang=js"
export * from "./gyycshAuditList.vue?vue&type=script&lang=js"
import style0 from "./gyycshAuditList.vue?vue&type=style&index=0&id=96f814f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f814f6",
  null
  
)

export default component.exports